<template>
    <div class="pa-4">
        <v-data-table
            :headers="headers"
            :items="items"
            class="elevation-1"
            :search="search">
            <template v-slot:top>
                <v-toolbar flat>
                    <v-toolbar-title>Vehicles</v-toolbar-title>
                    <v-divider class="mx-4" inset vertical />
                        <v-text-field v-model="search" append-icon="mdi-magnify" label="Search" single-line hide-details />
                    <v-spacer />
                    <v-dialog v-model="dialog" scrollable max-width="800px">
                        <template v-slot:activator="{ on, attrs}" v-if="$store.state.currentPagePriv.create">
                            <v-btn color="primary" dark class="mb-2" v-bind="attrs" v-on="on">
                                New Vehicle
                            </v-btn>
                        </template>
                        <v-card>
                            <v-card-title>
                                <span class="text-h5">{{ formTitle }}</span>
                            </v-card-title>
                            <v-divider />
                            <v-card-text>
                                <v-container fluid>
                                    <v-form ref="form" v-model="valid" lazy-validation>
                                        <v-row>
                                            <v-col cols="12" sm="6" md="6">
                                                <span>Plat Number</span>
                                                <v-text-field maxlength="10" v-model="editedItem.plate_number" filled rounded dense hide-details="auto" @keydown.space.prevent :readonly="editedIndex > -1" :rules="reqRule"> </v-text-field>
                                            </v-col>
                                            <v-col cols="12" sm="6" md="6">
                                                <span>Name</span>
                                                <v-text-field v-model="editedItem.name" filled rounded dense hide-details="auto" :rules="reqRule"></v-text-field>
                                            </v-col>
                                        </v-row>
                                        <v-row>
                                            <v-col cols="12" sm="6" md="6">
                                                <span>Type</span>
                                                <v-select outlined dense hide-details="auto" :items="vehicleTypes" item-text="description" item-value="code" v-model="editedItem.type" />
                                            </v-col>
                                            <v-col cols="12" sm="6" md="6">
                                                <span>Capacity</span>
                                                <v-text-field v-model="editedItem.capacity" filled rounded dense hide-details="auto" :rules="reqRule" suffix="cart"></v-text-field>
                                            </v-col>
                                        </v-row>
                                        <v-row>
                                            <v-col cols="12" sm="6" md="6">
                                                <span>Line</span>
                                                <v-select outlined dense hide-details="auto" :items="lines" item-text="description" item-value="code" return-object v-model="editedItem.lines" multiple />
                                            </v-col>
                                        </v-row>
                                    </v-form>
                                </v-container>
                            </v-card-text>
                            <v-divider />
                            <v-card-actions>
                                <v-spacer />
                                <v-btn color="blue darken-1" text @click="close">
                                    Cancel
                                </v-btn>
                                <v-btn color="blue darken-1" text @click="save">
                                    Save
                                </v-btn>
                            </v-card-actions>
                        </v-card>
                    </v-dialog>
                    <v-dialog v-model="dialogDelete" max-width="500px">
                        <v-card>
                            <v-card-title class="body-1 text-center">Anda akan menghapus vehicle ini ?</v-card-title>
                            <v-card-actions>
                                <v-spacer />
                                <v-btn color="blue darken-1" text @click="closeDelete">Cancel</v-btn>
                                <v-btn color="blue darken-1" text @click="deleteItemConfirm">OK</v-btn>
                                <v-spacer />
                            </v-card-actions>
                        </v-card>
                    </v-dialog>
                    <v-dialog v-model="dialogDetail" max-width="800px">
                        <v-card>
                            <v-card-title>
                                <span class="text-h5">Detail Vehicle</span>
                            </v-card-title>
                            <v-divider />
                            <v-card-text>
                                <v-container fluid>
                                    <v-row>
                                        <v-col cols="12" sm="6" md="6">
                                            <span class="font-weight-bold">Plat Number</span>
                                            <v-text-field v-model="viewedItem.plate_number" filled rounded dense hide-details="auto" readonly> </v-text-field>
                                        </v-col>
                                        <v-col cols="12" sm="6" md="6">
                                            <span class="font-weight-bold">Name</span>
                                            <v-text-field v-model="viewedItem.name" filled rounded dense hide-details="auto" readonly></v-text-field>
                                        </v-col>
                                    </v-row>
                                    <v-row>
                                        <v-col cols="12" sm="6" md="6">
                                            <span class="font-weight-bold">Type</span>
                                            <v-text-field :value="getTypeName(viewedItem.type)" filled rounded dense hide-details="auto" readonly></v-text-field>
                                        </v-col>
                                        <v-col cols="12" sm="6" md="6">
                                            <span class="font-weight-bold">Capacity</span>
                                            <v-text-field :value="viewedItem.capacity + ' cart'" filled rounded dense hide-details="auto" readonly></v-text-field>
                                        </v-col>
                                    </v-row>
                                    <v-row>
                                        <v-col cols="12" sm="12" md="12">
                                            <span class="font-weight-bold">Line</span>
                                            <div class="mt-2">
                                                <v-chip v-for="(line, idx) in viewedItem.lines" :key="idx" color="primary" outlined class="mr-2 mb-2">
                                                    {{ line.description }}
                                                </v-chip>
                                                <span v-if="!viewedItem.lines || viewedItem.lines.length === 0" class="grey--text">No lines assigned</span>
                                            </div>
                                        </v-col>
                                    </v-row>
                                </v-container>
                            </v-card-text>
                            <v-divider />
                            <v-card-actions>
                                <v-spacer />
                                <v-btn color="blue darken-1" text @click="closeDetail">
                                    Close
                                </v-btn>
                            </v-card-actions>
                        </v-card>
                    </v-dialog>
                </v-toolbar>
            </template>
            <template v-slot:[`item.actions`]="{ item }">
                <v-icon small class="mr-2" @click="viewDetail(item)">
                    mdi-eye
                </v-icon>
                <v-icon small class="mr-2" @click="editItem(item)" v-if="$store.state.currentPagePriv.update">
                    mdi-pencil
                </v-icon> 
                <v-icon small @click="deleteItem(item)" v-if="$store.state.currentPagePriv.delete">
                    mdi-delete
                </v-icon>
            </template>
            <template v-slot:no-data>
                <v-btn color="primary" @click="initialize">
                    Reset
                </v-btn>
            </template>
        </v-data-table>
    </div>
</template>

<script>
    export default {
        data: () => ({
            dialog: false,
            dialogDelete: false,
            dialogDetail: false,
            headers: [
                { text: 'Plat Number', value: 'plate_number' },
                { text: 'Name', value: 'name' },
                { text: 'Line', value: 'lines_names' },
                { text: 'Type', value: 'type_name' },
                { text: 'Capacity', value: 'capacity' },
                { text: 'Actions', value: 'actions', sortable: false },
            ],
            items: [],
            editedIndex: -1,
            editedItem: {},
            defaultItem: {},
            viewedItem: {},
            search: '',
            reqRule: [v => !!v || 'Harus diisi!'],
            valid: true
        }),
        
        computed: {
            formTitle () {
                return this.editedIndex === -1 ? 'New Vehicle' : 'Edit Vehicle'
            },
            lines() {
                let dataMiscCodes = this.$store.state.misccode.objs
                return dataMiscCodes.filter((i => i.type === 'Vehicle'))
            },
            vehicleTypes() {
                let dataMiscCodes = this.$store.state.misccode.objs
                return dataMiscCodes.filter((i => i.type === 'Vehicle Type'))
            },
        },

        watch: {
            dialog (val) {
                val || this.close()
            },
            dialogDelete (val) {
                val || this.closeDelete()
            },
            dialogDetail (val) {
                val || this.closeDetail()
            },
        },

        created() {
            this.initialize()
        },

        methods: {
            async initialize() {
                let response = await this.$store.dispatch('vehicle/getObjs')
                if (response.data.status=='success') this.items = response.data.data
            },

            viewDetail(item) {
                this.viewedItem = Object.assign({}, item)
                this.dialogDetail = true
            },

            getTypeName(code) {
                if (!code) return '-'
                const type = this.vehicleTypes.find(t => t.code === code)
                return type ? type.description : code
            },

            closeDetail() {
                this.dialogDetail = false
                this.$nextTick(() => {
                    this.viewedItem = {}
                })
            },

            editItem(item) {
                this.editedIndex = this.items.indexOf(item)
                this.editedItem = Object.assign({}, item)
                this.dialog = true
            },

            deleteItem (item) {
                this.editedIndex = this.items.indexOf(item)
                this.editedItem = Object.assign({}, item)
                this.dialogDelete = true
            },

            async deleteItemConfirm () {
                let url = this.$store.state.config.apiHost + "vehicles/" + this.editedItem.plate_number
                let response = await this.$axios.delete(url, {headers:{'Authorization': 'Bearer '+ this.$store.state.token, 'Content-Type': 'application/json'}})
                if (response.data.status=='success') this.items.splice(this.editedIndex, 1)
                this.closeDelete()
            },

            close () {
                this.resetForm()
                this.dialog = false
                this.$nextTick(() => {
                    this.editedItem = Object.assign({}, this.defaultItem)
                    this.editedIndex = -1
                })
            },

            closeDelete () {
                this.dialogDelete = false
                this.$nextTick(() => {
                    this.editedItem = Object.assign({}, this.defaultItem)
                    this.editedIndex = -1
                })
                this.resetForm()
            },

            async save () {
                await this.$refs.form.validate();
                if (!this.valid) return;

                if (this.editedIndex > -1) {
                    let url = this.$store.state.config.apiHost + "vehicles/" + this.editedItem.plate_number
                    let response = await this.$axios.put(url, JSON.stringify(this.editedItem), {headers:{'Authorization': 'Bearer '+ this.$store.state.token, 'Content-Type': 'application/json'}})
                    if (response.data.status=='success') Object.assign(this.items[this.editedIndex], this.editedItem)
                    this.close()
                    this.initialize();
                    this.$store.commit('setSnackbar', {saveSuccess: true, successMessage: 'Data Vehicle berhasil diupdate'})
                } else {
                    try {
                        let url = this.$store.state.config.apiHost + "vehicles"
                        let response = await this.$axios.post(url, JSON.stringify(this.editedItem), {headers:{'Authorization': 'Bearer '+ this.$store.state.token, 'Content-Type': 'application/json'}})
                        if (response.data.status=='success') this.items.push(this.editedItem)
                        this.close()
                        this.initialize()
                        this.$store.commit('setSnackbar', {saveSuccess: true, successMessage: 'Data Vehicle berhasil ditambahkan'})
                    }
                    catch (err) {
                        const keyword = 'duplicate key'
                        if (err.response.data.message.search(keyword) > -1){
                            return this.$store.commit('setSnackbar', {saveError: true, errorMessage: "Duplicate Key! Kode sudah terpakai."})
                        }
                        else {
                            return this.$store.commit('setSnackbar', {saveError: true, errorMessage: err.response.data.message})
                        }
                    }

                }
            },
            resetForm() {
                this.$refs.form.reset();
            },
        }
    }
</script>

<style>
.v-text-field fieldset, .v-text-field .v-input__control, .v-text-field .v-input__slot {
    border-radius: 7px!important;
}

</style>